export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4770.669ecf54.jpg";